module.exports = __webpack_public_path__ + "img/image2.6dbfc51f.jpg";